import { createGlobalStyle } from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

const GlobalStyle = createGlobalStyle`

    * {
        box-sizing: border-box;
    }
    
    #wrapper{
        display: flex;
        height: 100%;
        flex-direction: column;
        color: #000;
        background-color: #1a1a1a;

        h1 {
            margin: 0;
        }
        
        h2 {
            font-size: 1.5em;
            font-weight: 700;
        }
        
        .megamenu {
            flex: none;
        }
    
        #root {
            font-family: 'Sintony', Arial, sans-serif;
            flex: 1 0 auto;
            
            ${BaseStyle.Mixins.screenSizes.large} {
                margin: 0 auto;
                width: 100%;
                max-width: 1440px;
            }
        }
    
        .site-footer {
            flex: none;

            @media print {
                display: none;
            }
        }
    }
    
    /* Overwriting some of bams styles for global styling */
    #pageWrapper a[disabled] {
        color: #cdcdcd;
    }
    
    .message-banner-container {
        z-index: 1040;
    }
    
    a {
        transition: none;
    }
`;

export default GlobalStyle;
